export default function Contact() {
  return (
    <section id="contact" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Get in <span className="text-blue-600">Touch</span>
          </h2>
          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            Have questions or need assistance? We're here to help you every step of the way
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          <div className="space-y-8">
            <div className="flex items-start gap-6">
              <div className="w-14 h-14 bg-blue-50 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-phone-line text-2xl text-blue-600"></i>
              </div>
              <div>
                <h4 className="text-lg font-bold text-gray-900 mb-2">Phone Numbers</h4>
                <p className="text-base text-gray-600 mb-1"><a href="tel:+2348164095400" target="_blank" rel="noopener noreferrer">+2348164095400</a></p>
                <p className="text-base text-gray-600"><a href="tel:+2347010111298" target="_blank" rel="noopener noreferrer">+2347010111298</a></p>
              </div>
            </div>

            <div className="flex items-start gap-6">
              <div className="w-14 h-14 bg-orange-50 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-mail-line text-2xl text-orange-600"></i>
              </div>
              <div>
                <h4 className="text-lg font-bold text-gray-900 mb-2">Email Address</h4>
                <p className="text-base text-gray-600"><a href="mailto:info@thinkpacktech.com.ng" target="
                _blank">info@thinkpacktech.com.ng</a></p>
              </div>
            </div>

            <div className="flex items-start gap-6">
              <div className="w-14 h-14 bg-green-50 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-map-pin-line text-2xl text-green-600"></i>
              </div>
              <div>
                <h4 className="text-lg font-bold text-gray-900 mb-2">Office Address</h4>
                <p className="text-base text-gray-600 leading-relaxed">
                  Sabuwar Hanya Tudun Wada<br />
                  Gusau, Zamfara State<br />
                  Nigeria
                </p>
              </div>
            </div>

            <div className="flex items-start gap-6">
              <div className="w-14 h-14 bg-blue-50 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-global-line text-2xl text-blue-600"></i>
              </div>
              <div>
                <h4 className="text-lg font-bold text-gray-900 mb-2">Website</h4>
                <a
                  href="https://www.thinkpacktech.com.ng"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-base text-blue-600 hover:text-blue-700 transition-colors"
                >
                  www.thinkpacktech.com.ng
                </a>
              </div>
            </div>

            <div className="pt-6">
              <h4 className="text-lg font-bold text-gray-900 mb-4">Business Hours</h4>
              <div className="space-y-2 text-sm text-gray-600">
                <p>Monday - Friday: 8:00 AM - 6:00 PM</p>
                <p>Saturday: 9:00 AM - 4:00 PM</p>
                <p>Sunday: Closed</p>
              </div>
            </div>
          </div>

          <div className="bg-white p-10 rounded-2xl shadow-xl">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Send us a Message</h3>
            <form className="space-y-6">
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Full Name
                </label>
                <input
                  type="text"
                  placeholder="Enter your full name"
                  className="w-full px-4 py-3 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Email Address
                </label>
                <input
                  type="email"
                  placeholder="your.email@example.com"
                  className="w-full px-4 py-3 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Phone Number
                </label>
                <input
                  type="tel"
                  placeholder="08012345678"
                  className="w-full px-4 py-3 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Subject
                </label>
                <input
                  type="text"
                  placeholder="How can we help you?"
                  className="w-full px-4 py-3 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Message
                </label>
                <textarea
                  rows={5}
                  placeholder="Tell us more about your inquiry..."
                  className="w-full px-4 py-3 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
                ></textarea>
              </div>

              <button
                type="submit"
                className="w-full bg-blue-600 text-white px-6 py-4 rounded-lg text-base font-semibold hover:bg-blue-700 transition-colors whitespace-nowrap"
              >
                Send Message
              </button>
            </form>
          </div>
        </div>

        <div className="mt-16">
          <div className="w-full h-96 rounded-2xl overflow-hidden shadow-xl">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3911.234567890123!2d6.6666667!3d12.1666667!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTLCsDEwJzAwLjAiTiA2wrA0MCcwMC4wIkU!5e0!3m2!1sen!2sng!4v1234567890123!5m2!1sen!2sng"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Thinkpack Technologies Location"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}